import React from 'react'
import { bool } from 'prop-types';
import './styles.scss';

const Loading = ({ visible = false }) => {
  
  return (
    <>
        <div className={visible ? ("Loading Loading__show") : ("Loading Loading__hide")} >
            <div className="Loading__spinner">
                <div className="Loading__spinner-circle"></div>
                <div className="Loading__spinner-circle"></div>
                <div className="Loading__spinner-circle"></div>
                <div className="Loading__spinner-circle"></div>
            </div>
        </div>
    </>
  )
}

Loading.propTypes = {
  visible: bool
};


export default Loading;
